import axios, { AxiosInstance } from 'axios';
import env from 'react-native-config';
import { setupRequestInterceptors } from 'app/api/interceptors/requestInterceptors';
import { setupResponseInterceptors } from 'app/api/interceptors/responseInterceptors';

export const createAxiosInstance = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: env.API_URL,
    timeout: 20_000,
  });

  setupRequestInterceptors(instance);
  setupResponseInterceptors(instance);

  return instance;
};

export const axiosInstance = createAxiosInstance();
